import {
    Dispatch,
    SetStateAction,
    useCallback,
    useEffect,
    useState,
} from "react";
import { COUNT, TYPE } from "../types/index";

interface IUseCountInputReturn {
  numberOfTeen: number;
  numberOfAdult: number;
  numberOfChildren: number;
  handleTypeCount: (count: CountAction, type: CountType) => void;
  setNumberOfAdult: Dispatch<SetStateAction<number>>;
  setNumberOfChildren: Dispatch<SetStateAction<number>>;
  setNumberOfTeen: Dispatch<SetStateAction<number>>;
}

type CountTypeKeys = keyof typeof TYPE;
export type CountType = (typeof TYPE)[CountTypeKeys];

type CountActionKeys = keyof typeof COUNT;
export type CountAction = (typeof COUNT)[CountActionKeys];

const useCountInput = (): IUseCountInputReturn => {
  const [numberOfAdult, setNumberOfAdult] = useState<number>(
    typeof window !== "undefined" &&
      JSON.parse(String(localStorage.getItem("USER_SEARCH_QUERY_PARAMS")))
        ?.travelers?.adults
      ? JSON.parse(String(localStorage.getItem("USER_REQUEST_QUOTE")))
          ?.travelers?.adults
        ? JSON.parse(String(localStorage.getItem("USER_REQUEST_QUOTE")))
            .travelers.adults
        : JSON.parse(String(localStorage.getItem("USER_SEARCH_QUERY_PARAMS")))
            .travelers.adults
      : 2
  );
  const [numberOfTeen, setNumberOfTeen] = useState<number>(
    typeof window !== "undefined" &&
      JSON.parse(String(localStorage.getItem("USER_SEARCH_QUERY_PARAMS")))
        ?.travelers?.teens
      ? JSON.parse(String(localStorage.getItem("USER_REQUEST_QUOTE")))
          ?.travelers?.teens
        ? JSON.parse(String(localStorage.getItem("USER_REQUEST_QUOTE")))
            .travelers.teens
        : JSON.parse(String(localStorage.getItem("USER_SEARCH_QUERY_PARAMS")))
            .travelers.teens
      : 0
  );
  const [numberOfChildren, setNumberOfChildren] = useState<number>(
    typeof window !== "undefined" &&
      JSON.parse(String(localStorage.getItem("USER_SEARCH_QUERY_PARAMS")))
        ?.travelers?.children
      ? JSON.parse(String(localStorage.getItem("USER_REQUEST_QUOTE")))
          ?.travelers?.children
        ? JSON.parse(String(localStorage.getItem("USER_REQUEST_QUOTE")))
            .travelers.children
        : JSON.parse(String(localStorage.getItem("USER_SEARCH_QUERY_PARAMS")))
            .travelers.children
      : 0
  );

  const handleTypeCount = useCallback(
    (count: CountAction, type: CountType) => {
      switch (type) {
        case TYPE.adult:
          if (count === COUNT.increment) setNumberOfAdult(numberOfAdult + 1);
          else if (count === COUNT.decrement)
            if (numberOfAdult === 1) {
              return numberOfAdult;
            }
          setNumberOfAdult(numberOfAdult - 1);
          break;
        case TYPE.teen:
          if (count === COUNT.increment) setNumberOfTeen(numberOfTeen + 1);
          else if (count === COUNT.decrement)
            if (numberOfTeen === 0) {
              return numberOfTeen;
            }
          setNumberOfTeen(numberOfTeen - 1);
          break;
        case TYPE.children:
          if (count === COUNT.increment)
            setNumberOfChildren(numberOfChildren + 1);
          else if (count === COUNT.decrement)
            if (numberOfChildren === 0) {
              return numberOfChildren;
            }
          setNumberOfChildren(numberOfChildren - 1);
          break;
      }
    },
    [numberOfAdult, numberOfChildren, numberOfTeen]
  );

  useEffect(() => {
    const CURRENT_STATE = localStorage.getItem("USER_REQUEST_QUOTE") || null;
    if (CURRENT_STATE !== null) {
      const parsedCurrentState = JSON.parse(CURRENT_STATE) || {};
      const travelers = {
        adults: numberOfAdult,
        teens: numberOfChildren,
        children: numberOfTeen,
      };
      parsedCurrentState.travelers = travelers;
      localStorage.setItem("USER_REQUEST_QUOTE", JSON.stringify(CURRENT_STATE));
    }
  }, [numberOfAdult, numberOfChildren, numberOfTeen]);

  return {
    numberOfTeen,
    numberOfAdult,
    numberOfChildren,
    handleTypeCount,
    setNumberOfAdult,
    setNumberOfChildren,
    setNumberOfTeen,
  };
};

export default useCountInput;
